import React from "react";
import axios from "axios";
import SideBar from "../../SideBar";
import { useEffect, useState, useRef } from "react";

import { Link, useLocation } from "react-router-dom";
import ReactShadowScroll from "react-shadow-scroll";
import useCollapse from "react-collapsed";
import HeaderName from "../../HeaderName";
import TransferDialog from "./transferModal";
import {
  FaCashRegister,
  FaFileMedical,
  FaArrowLeft,
  FaAngleDown,
  FaRegEdit,
  FaAngleUp,
  FaList,
  FaRegUser,
  FaRegTrashAlt,
  FaClipboardCheck,
  FaPowerOff,
} from "react-icons/fa";

import { useSelector } from "react-redux";
import Swal from "sweetalert2";
function Dashboard() {
  const token = localStorage.getItem("token");
  const url = process.env.REACT_APP_APP_URL;
  // const url = "http://localhost:9000/api/";
  const api = axios.create({
    baseURL: url,
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    },
  });

  const [scroll, setScroll] = useState(true);
  const [isExpanded, setExpanded] = useState(false);
  const [isAccData, setAccData] = useState(false);

  const { getCollapseProps, getToggleProps } = useCollapse();

  const handleAdminChange = () => {
    setExpanded(!isExpanded);
  };

  const handleAccChange = () => {
    setAccData(!isAccData);
  };
  const [purchaseLists, setPurchaseLists] = useState([]);
  const [purchaseDetail, setPurchaseDetail] = useState([]);
  const [accModalData, setAccModalData] = useState([]);
  const [open, setOpen] = useState(false);

  const [showUpdate, setShowUpdate] = useState(false);
  const [id, setId] = useState("");
  const [cashList, setCashList] = useState([]);
  const showDialog = () => setOpen(true);

  const [date, setDate] = useState("");
  const [showOrigin, setShowOrigin] = useState(true);
  const [showFilter, setShowFilter] = useState(false);
  const [accID, setAccID] = useState("");
  const [closingCash, setClosingCash] = useState("");
  const [openingCash, setOpeningCash] = useState("");
  const [medicineTotal, setMedicineTotal] = useState("");
  const [expenseTotal, setExpenseTotal] = useState("");
  const [incomeTotal, setIncomeTotal] = useState("");
  const [total, setTotal] = useState("");
  const [TVTotal, setTVTotal] = useState("");
  const [name, setName] = useState("");
  const [bankList, setBankList] = useState([]);
  const [showCashAcc, setShowCashAcc] = useState(false);
  const [showBankAcc, setShowBankAcc] = useState(false);
  const [acc, setAcc] = useState("");
  const [type, setType] = useState("");
  const [transferAmount, setTransferAmount] = useState("");
  const [cashID, setCashID] = useState("");
  const [branchLists, setBranchLists] = useState([]);
  const [branch, setBranch] = useState("");
  const showCurrencyUpdate = (val) => {
    setId(val);
    setShowUpdate(true);
  };

  const handleType = (name) => {
    setType(name);
    if (name == "Bank") {
      setBankList(bankList);
      setShowBankAcc(true);
      setShowCashAcc(false);
    } else {
      setCashList(cashList);
      setShowBankAcc(false);
      setShowCashAcc(true);
    }
  };

  const filter = async () => {
    setShowFilter(true);
    setShowOrigin(false);
    console.log(acc, "acc id");
    // if (acc) {
    //   setBankID(bankList.filter(el => el._id === acc))
    // } else {
    //   setCashID(cashList.filter(el => el._id === acc))
    // }
    console.log(
      cashList.filter((el) => el._id === acc),
      "c id"
    );

    // console.log(cashList.filter(el => el._id === acc)[0]._id, 'c id')

    try {
      Swal.fire({
        title: "Please Wait",
        allowEscapeKey: false,
        allowOutsideClick: false,

        showConfirmButton: false,

        timer: 1000,
        timerProgressBar: true,
      });
      Swal.showLoading();

      if (acc) {
        setName(cashList.filter((el) => el._id === acc)[0].name);
      }

      let data = {
        exact: date,
        // relatedAccounting: acc,
        relatedCash: cashList.filter((el) => el._id === acc)[0]._id,
        // relatedBranch: branch,
        type: "Opening",
      };
      if (branch == "HO") {
      } else {
        data.relatedBranch = branch;
      }
      if (cashList.filter((el) => el._id === acc)[0]._id) {
        data.relatedAccounting = cashList.filter((el) => el._id === acc)[0]._id;
      } else {
        data.relatedAccounting = bankList.filter((el) => el._id === acc)[0]._id;
      }

      await api
        .get(`account-balances/opening-closing`, {
          params: data,
        })
        .then((res) => {
          console.log(res.data, "data");
          setAccModalData(res.data);
          setClosingCash(res.data.closingCash);
          setOpeningCash(res.data.openingTotal);
          setMedicineTotal(res.data.medicineTotal);
          setExpenseTotal(res.data.expenseTotal);
          setIncomeTotal(res.data.incomeTotal);
          setTotal(res.data.total);
          setTVTotal(res.data.TVTotal);
          setTransferAmount(res.data.transferBalances);
        });
    } catch (error) {
      Swal.fire({
        title: "Something Wrong!",
        text: "Data Not Found !",
        icon: "warning",
        // showCancelButton: true,

        cancelButtonText: "Close",
      });
    }
  };
  const print = () => {
    // document.getElementById('printtop').style({ marginTop: '100px' })

    // document.getElementById('printtop').style.position = 'running(footer)'

    let printContents = document.getElementById("print").innerHTML;
    let originalContents = document.body.innerHTML;
    document.body.innerHTML = printContents;
    window.print();
    document.body.innerHTML = originalContents;
    window.location.reload();
  };

  useEffect(() => {
    const getPurchaseLists = async () => {
      try {
        const res = await api.get("purchases");

        setPurchaseLists(res.data.list);
      } catch (err) { }
    };

    const getRelatedMedicineLists = async () => {
      try {
        const res = await api.get("purchases");
        console.log(res.data.data);
        setPurchaseDetail(res.data.data);
      } catch (err) { }
    };

    const getAccLists = async () => {
      try {
        const res = await api.get("accounting-lists");
        console.log(res.data.list, "bank");

        setCashList(
          res.data.list.filter(
            (el) =>
              el.relatedHeader.name == "Cash In Hand" &&
              el.relatedType.name == "Assets"
          )
        );
        setBankList(
          res.data.list.filter(
            (el) =>
              el.relatedHeader.name == "Cash At Bank" &&
              el.relatedType.name == "Assets"
          )
        );
      } catch (err) { }
    };

    const getBranches = async () => {
      try {
        const res = await api.get("branches");
        setBranchLists(res.data.list);
      } catch (err) {
        alert(err.message);
      }
    };
    getBranches();

    getAccLists();

    getPurchaseLists();
    getRelatedMedicineLists();
    if (scroll) {
      document.body.style.overflow = "scroll";
    } else {
      document.body.style.overflow = "hidden";
    }
  }, []);

  const handleTransfer = () => {
    console.log("hi there");
  };
  return (
    <div classNameName='App'>
      {/* <!-- end preloader --> */}
      {/* @include('sweet::alert') */}

      <div className='wrapper'>
        {/* <!-- Navbar --> */}
        <HeaderName />

        <SideBar />

        {/* <!-- /.navbar --> */}

        {/* <!-- Main Sidebar Container --> */}

        {/* <!-- Content Wrapper. Contains page content --> */}
        <div className='content-wrapper'>
          {/* <!-- Content Header (Page header) --> */}
          <div className='content-header'>
            <div className='container-fluid'>
              <div className='row mb-2'>
                <div className='col-sm-12'>
                  <ol className='breadcrumb'>
                    <li className='breadcrumb-item'>
                      <Link to='/dash'>
                        <i>
                          <FaArrowLeft />
                        </i>
                      </Link>
                    </li>
                    <li
                      className='breadcrumb-item active'
                      style={{ marginTop: "0.1em" }}
                    >
                      Account Report
                    </li>
                  </ol>
                </div>
              </div>
            </div>
          </div>

          {/* <!-- Main content --> */}
          <section class='content'>
            <div class=''>
              <div className='row ml-2'>
                <div className='offset-1 card col-10'>
                  <div className='row mt-4 '>
                    <div className='col-3 form-group'>
                      <label>Date</label>
                      <input
                        type='date'
                        className='rounded-2 form-control'
                        onChange={(e) => setDate(e.target.value)}
                      />
                    </div>
                    <div className='col-md-2' style={{ marginTop: "0.4em" }}>
                      <div className='form-group'>
                        <label>Type</label>

                        <select
                          name='currency'
                          id=''
                          className='form-control '
                          // onchange='convert(this.value)'
                          // placeholder='Filter By Branches'
                          onChange={(e) => handleType(e.target.value)}
                        >
                          <option hidden>Select</option>

                          <option value='Bank'>Bank</option>
                          <option value='Cash'>Cash</option>

                          {/* {branchLists.map(option => (
                            <option value={option._id}>{option.name}</option>
                          ))} */}
                        </select>
                      </div>
                    </div>

                    <div className='col-md-3' style={{ marginTop: "0.4em" }}>
                      <div className='form-group'>
                        <label>Account</label>

                        <select
                          name='currency'
                          id=''
                          className='form-control '
                          // onchange='convert(this.value)'
                          // placeholder='Filter By Branches'
                          onChange={(e) => setAcc(e.target.value)}
                        >
                          <option hidden>Select</option>
                          {showBankAcc &&
                            bankList.map((option) => (
                              <option value={option._id}>{option.name}</option>
                            ))}{" "}
                          {showCashAcc &&
                            cashList.map((option) => (
                              <option value={option._id}>{option.name}</option>
                            ))}
                        </select>
                      </div>
                    </div>
                    <div className='col-md-2' style={{ marginTop: "2.3em" }}>
                      <div className='form-group'>
                        <select
                          name='currency'
                          id=''
                          className='form-control '
                          // onchange='convert(this.value)'
                          // placeholder='Filter By Branches'
                          onChange={(e) => setBranch(e.target.value)}
                        >
                          <option hidden>Filter By Branches</option>
                          <option value='HO'>HO</option>

                          {branchLists.map((option) => (
                            <option value={option._id}>{option.name}</option>
                          ))}
                        </select>
                      </div>
                    </div>

                    <div className='col-2'>
                      <button
                        type='button'
                        className='btn  btn-primary'
                        style={{ marginTop: "2em" }}
                        onClick={filter}
                      >
                        Search
                      </button>
                    </div>
                  </div>
                </div>

                <div
                  className='card offset-1 col-10 mt-1 px-5'
                  id='print'
                  style={{ border: "1px solid light" }}
                >
                  <div className='row'>
                    <h2 className='card-header mr-2 fs-2 text-center py-3 mt-2'>
                      Account Report For {name} <br />
                      {date && <>({date ? date.split(",")[0] : ""})</>}
                    </h2>
                  </div>

                  <div
                    className='row py-3'
                    style={{ marginLeft: "5em", fontSize: "18px" }}
                  >
                    {/* {purchaseLists.map(purList => ( */}

                    <div className='row py-2 d-flex justify-content-between'>
                      <div className='col-6 fs-4'>Opening Cash</div>

                      <div className='offset-2 col-3'>
                        {openingCash ? openingCash : 0} MMK
                      </div>
                    </div>
                    <div
                      className='row  py-2
 d-flex justify-content-between'
                    >
                      <div className='col-6 fs-4'>Medicine Sale</div>
                      <div className='offset-2 col-3'>
                        {medicineTotal ? medicineTotal : 0} MMK
                      </div>
                    </div>
                    <div
                      className='row py-2 d-flex justify-content-between
'
                    >
                      <div className='col-6 fs-4'>Treatment Sale</div>
                      <div className='offset-2 col-3'>
                        {TVTotal ? TVTotal : 0} MMK
                      </div>
                    </div>
                    <div
                      className='row py-2 d-flex justify-content-between
'
                    >
                      <div className='col-6 fs-4'>Other Income</div>
                      <div className='offset-2 col-3'>
                        {incomeTotal ? incomeTotal : 0} MMK
                      </div>
                    </div>
                    <div className='row py-2'>
                      <div className='col-6 fs-4'>Total</div>
                      <div className='offset-3 col-2'>
                        {total ? total : 0} MMK
                      </div>
                    </div>
                    <div
                      className='row py-2 d-flex justify-content-between
'
                    >
                      <div className='col-6 fs-4'>Other Expense</div>
                      <div className='offset-2 col-3'>
                        {expenseTotal ? expenseTotal : 0} MMK
                      </div>
                    </div>
                    <div
                      className='row py-2 d-flex justify-content-between
'
                    >
                      <div className='col-6 fs-4'>Grand Total</div>
                      <div className='offset-2 col-3'>
                        {closingCash ? closingCash : 0} MMK
                      </div>
                    </div>
                    <div
                      className='row py-2 d-flex justify-content-between
'
                    >
                      <div className='col-6 fs-4'>Transfer Amount</div>
                      <div className='offset-2 col-3'>
                        {transferAmount ? transferAmount : 0} MMK
                      </div>
                    </div>
                    <div
                      className='row py-2 d-flex justify-content-between
'
                    >
                      <div className='col-6 fs-4'>Closing Cash</div>
                      <div className='offset-2 col-3'>
                        {closingCash - transferAmount
                          ? closingCash - transferAmount
                          : 0}{" "}
                        MMK
                      </div>
                    </div>

                    {/* ))} */}
                  </div>
                </div>
                <div className='d-flex justify-content-center gap-3 mb-3 mt-3'>
                  <button
                    type='button'
                    onClick={showDialog}
                    className='btn btn-sm btn-primary mb-2 rounded-1'
                  >
                    Transfer
                  </button>
                  <button
                    type='button'
                    onClick={print}
                    className='btn btn-sm btn-success mb-2 rounded-1'
                  >
                    Print
                  </button>
                </div>
              </div>
            </div>
            <TransferDialog
              open={open}
              close={() => setOpen(false)}
              setOpen={setOpen}
              setAccModalData={setAccModalData}
              accModalData={accModalData}
              closingCash={
                closingCash - transferAmount ? closingCash - transferAmount : 0
              }
            />
          </section>
        </div>

        {/* <!-- /.content-wrapper --> */}
        <footer className='main-footer'>
          <strong>
            Copyright &copy; 2017-2020{" "}
            <a href='http://www.kwintechnologies.com'>K-win Technology</a>.
          </strong>
          All rights reserved.
        </footer>

        {/* <!-- Control Sidebar --> */}
        <aside classNameName='control-sidebar control-sidebar-dark'>
          {/* <!-- Control sidebar content goes here --> */}
        </aside>

        {/* <!-- /.control-sidebar --> */}
      </div>
      {/* <!-- ./wrapper --> */}
    </div>
  );
}
export default Dashboard;
